import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-typeahead';
import { CodeDescription } from '../../../models/code-description.model';
import { MasterDataManagementService } from '../../../services/master-data-management.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-edit-shops-shop-information',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './edit-shops-shop-information.component.html',
  styleUrls: ['./edit-shops-shop-information.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EditShopsShopInformationComponent implements OnInit, AfterViewInit {
  @Input() formGroup!: FormGroup;

  // Shop Type options
  shopTypes: CodeDescription[] = [
    { code: 'MANUFACTURER_PARTS_WITH_DISCOUNT', description: '1 - Using Manufacturer Parts with Discount' },
    { code: 'MAERSK_SUPPLIED_PARTS', description: '2 - Using Maersk Supplied Parts' },
    { code: 'MANUFACTURER_PARTS', description: '3 - Using Manufacturer Parts' },
    { code: 'SHOP_AND_MAERSK_SUPPLIED_PARTS', description: '5 - Using Shop and Maersk Supplied Parts' },
  ];

  locationCodesList: { label: string; value: string }[] = [];
  isLoadingLocations: boolean = false;

  constructor(private masterDataManagementService: MasterDataManagementService) {}

  ngOnInit(): void {
    this.loadLocationCodes();
  }

  ngAfterViewInit(): void {
    // Disable shopCode field in edit mode after view init
    setTimeout(() => {
      this.formGroup.get('shopCode')?.disable({ emitEvent: false });
    }, 0);
  }

  async loadLocationCodes(): Promise<void> {
    this.isLoadingLocations = true;
    try {
      const locations = await firstValueFrom(this.masterDataManagementService.getLocationCodes());
      this.locationCodesList = [...locations];
    } catch (err) {
      console.error('Error loading location codes', err);
      this.locationCodesList = [];
    } finally {
      this.isLoadingLocations = false;
    }
  }

  onLocationSelected(event: any): void {
    const selectedValue = event.target?.value || event.detail?.value || '';
    this.formGroup.get('shopLocation')?.setValue(selectedValue);
  }

  isControlInErrorState(control: FormControl | any): boolean | null {
    return control?.invalid && control?.touched ? true : null;
  }
}
